export const SliderData = [
    {
        image: '/images/image-product-1.jpg'
    },

    {
        image: '/images/image-product-2.jpg'
    },

    {
        image: '/images/image-product-3.jpg'
    },

    {
        image: '/images/image-product-4.jpg'
    }
]